module.exports = __webpack_public_path__ + "img/evse_item.2bfac8bb.svg";